import React, {useEffect} from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { Provider } from 'react-redux';
import {store} from './store';
import ErrorBoundary, { initErrorMonitor } from './lib/errorMonitor'
import './i18n';

import {
    initMatomoTracker,
    setMatomoVisitorId,
    trackPageView,
    trackVisitorSessionStart
} from './hooks/useMatomoTrackingPoint';
import {getLocalForage, getLocalStorage, setLocalForage, setLocalStorage} from "./util/storage";
import {generateDeviceId, getUserInfo} from "./util/author";
import { initViewport } from './util/viewport';
import {
    attributionQuerySummary,
    captureRegistrationAttributionVisit,
    getOrCreateKreneVisitorId,
    setSharedLoginState
} from "./util/registrationAttribution";

// 维护期间检查：如果处于维护状态，直接跳转到404页面
const isMaintenanceMode = false;
if (isMaintenanceMode) {
    const publicUrl = process.env.PUBLIC_URL || '';
    window.location.href = `${publicUrl}/404.html`;
}

initMatomoTracker({
    urlBase: process.env.REACT_APP_API_MATOMO_TRACKER || '',
    siteId: 1,
    userId: getUserInfo()?.uuid,
    // 其他配置选项...
});
setMatomoVisitorId(getOrCreateKreneVisitorId());

// 初始化错误监控
initErrorMonitor();

// 移动端 viewport 适配（<= 768px 时设置 rem 基准）
initViewport();

const getOrCreateDeviceId = () => {
    let deviceId = getLocalStorage('device_id');
    if (!deviceId) {
        deviceId = generateDeviceId();
        setLocalStorage('device_id', deviceId);
    }
    return deviceId;
};

const deviceId = getOrCreateDeviceId();

document.addEventListener('DOMContentLoaded', (event) => {
    const userInfo = getUserInfo();
    const loginStatus = userInfo ? 'logged_in' : 'anonymous';
    setSharedLoginState(Boolean(userInfo), userInfo?.uuid);
    const attributionState = captureRegistrationAttributionVisit(loginStatus);
    const load_time = performance.now();
    const page_id = window.location.href;
    const referrer = attributionState?.source.referrer || document.referrer || '';
    const utm = attributionQuerySummary(attributionState);
    const landingPage = attributionState?.landing.fullUrl || window.location.href;
    if (userInfo) {
        trackPageView({load_time, page_id, referrer, utm, login_status: loginStatus})
    }else {
        trackVisitorSessionStart({
            device_id: deviceId,
            browser: navigator.userAgent,
            country: '',
            utm,
            referrer,
            landing_page: landingPage,
            login_status: loginStatus,
        })
    }
});

const root = ReactDOM.createRoot(
    document.getElementById('root') as HTMLElement
);

root.render(
    <React.StrictMode>
        <Provider store={store}>
            <ErrorBoundary>
                <App />
            </ErrorBoundary>
        </Provider>
    </React.StrictMode>
);

reportWebVitals();
